import * as angular from "angular";
import {IController, IQService, ITimeoutService} from "angular";
import * as _ from "lodash";
import {MapFactoryService} from "../../services/map.service";
import {MapsCommonService} from "../../services/mapsCommon.service";
import {MapPolygonDrawService, MapRectangleSelectSession, MapSelectionDrawSession} from "../../services/map-polygon-draw.service";
import {AccountModel} from "../../../account/angular/models/account.model";
import {SplitService} from "../../../commons/services/split-service.service";
import {AgentsService} from "../../../agents/services/agents-service.service";
import {ServiceAreasService} from "../../../service-areas/services/service-areas-service.service";
import {escapeHtml} from "../../../commons/utils/html-escape.util";

declare var MarkerClusterer: any;

export class ServicesMapComponent implements IController {
  from: any;
  to: any;
  services: any;
  agents: any;
  depots: any;
  accounts: AccountModel[];
  route: any;
  selectedAgent: any;
  selectedServiceIds: any;
  selectedServiceAreaIds: any;
  highlightedTaskId: any;
  addDeliveries: Function;
  highlightedTaskChanged: Function;
  selectedServicesChanged: Function;
  selectedAgentChanged: Function;

  private TOOLTIP_TIMEOUT_MS: number = 500;
  private serviceAreasRef: any;
  private taskRef: any;
  private deliveriesRef: any;
  private infowindow = new google.maps.InfoWindow()
  private siteLocation: any;
  private MIN_TASKS_TO_CLUSTER: number = 400
  private mapTypeIds: any = {
    roadmap: 'ROADMAP',
    satellite: 'SATELLITE'
  }
  private defaultPolygonOptions: any = {
    fillColor: '#676767',
    fillOpacity: 0.4,
    strokeWeight: 2,
    strokeColor: '#6060FB',
    clickable: true,
    editable: false,
    zIndex: 3
  };
  private myLocation: any = undefined;
  private agentTaskMarkers: any = [];
  // private services: any = [];
  private customPolygons: any = [];
  private serviceAreaList: any = [];
  private doCluster = false;
  private doDepotCluster: any = true;
  private mapPolygons: any = [];
  private polygonConfig: any = {
    clickable: true
  };
  private filters: any = {
    tasks: true,
    traffic: false,
    satellite: false,
    itinerary: true,
    depots: true,
    accounts: true,
    selectedTasksOnly: false,
    agents: true,
    showAgentsWithoutGpsPermissions: true,
    polygons: true,
    colorizeBy: 'TYPE'
  };
  private clusterGridSizes: any = {
    'S': 30,
    'M': 60,
    'L': 90
  };
  private taskInfoWindow: any;
  private depotInfoWindow: any;
  private agentInfoWindow: any;
  private clusterActiveWindow: any;
  private programTypesMap: any;
  private markerCluster: any;
  private map: any;
  drawSession: MapSelectionDrawSession;
  private mapInstance: google.maps.Map;
  private mapRef: any;
  private isReady: boolean;
  private polygonEvents: any;
  private depotClusterEvents: any;
  private servicesDataLayerRef: any;
  private routeDataLayerRef: any;
  private slaDates: any;
  private isClusterEnabled: boolean;
  private depotActiveWindow: any;
  private hoveringTaskId: any;
  private taskInfoWindowModel: any;
  private heatDataLayerRef: any;
  private agentInfoWindowModel: any;
  private depotInfoWindowModel: any;
  private serviceAreasList: any;
  private agentActiveWindow: any;
  private windowParams: any;
  private activeWindow: any;
  private depotsWindowParams: any;
  private agentTaskMarkersLayer: any;
  public agentsMarkersLayer: any;
  public accountsMarkersLayer: any;
  public depotsMarkersLayer: any;
  private isDoubleClick: boolean;
  private rectangleSelectSession: MapRectangleSelectSession;

  constructor(private $q: IQService, private $log, private $task,
              private mapsCommonService: MapsCommonService, private mapPolygonDrawService: MapPolygonDrawService, private $deliveries,
              private $serviceArea, private $timeout: ITimeoutService, private uiGmapIsReady,
              private UUIDService, private mapFactoryService: MapFactoryService, private agentsService: AgentsService,
              private tasksConstants, private moment, private splitService: SplitService, private $mdMedia, private serviceAreasService: ServiceAreasService) {
    this.filters.showAgentsWithoutGpsPermissions = !this.splitService.getEnableLocationTrackingFilterByDefault();
  }

  $onInit() {
    this.drawSession = this.mapPolygonDrawService.createSelectionSession({
      $timeout: this.$timeout,
      polygonOptions: this.defaultPolygonOptions,
      onRectangleComplete: () => {
      },
      onPolygonComplete: (polygon) => {
        if (!this.customPolygons.length) {
          this.drawSession.showDeleteToolOverlay(true);
        }
        this.addCustomPolygon(polygon);
        this.addPolygonClickEventListener(polygon);
        this.togglePolygonServiceIds(polygon);
      },
      onDeleteCustomPolygons: () => {
        this.mapsCommonService.removeCustomPolygons(this.customPolygons);
        this.customPolygons = [];
      }
    });

    this.rectangleSelectSession = this.mapPolygonDrawService.createRectangleSelectSession({
      onComplete: (bounds) => {
        const idsToSelect = this.getIdsToSelectByBounds(bounds);
        if (idsToSelect.length) {
          this.$timeout(0).then(() => {
            this.selectServiceIds(idsToSelect);
          });
        }
      },
      onModeChange: (mode) => {
        this._applyLayerClickability();
        if (this.map && this.map.options) {
          this.map.options.draggable = mode === 'pan';
        }
      }
    });

    this.serviceAreasRef = this.$serviceArea();
    this.taskRef = this.$task();
    this.deliveriesRef = this.$deliveries();
    this.siteLocation = this.mapsCommonService.getSiteLocation();
    this.taskInfoWindow = this.mapsCommonService.initActiveWindow({
      pixelOffset: new google.maps.Size(0, -40),
      disableAutoPan: true
    });
    this.depotInfoWindow = this.mapsCommonService.initActiveWindow();
    this.agentInfoWindow = this.mapsCommonService.initActiveWindow();
    this.clusterActiveWindow = this.mapsCommonService.initActiveWindow();
    this.infowindow.setOptions({disableAutoPan: true})
    this.programTypesMap = this.splitService.getSiteProgramTypesMap();
    this.map = {
      isReady: false,
      center: this.siteLocation,
      zoom: 12,
      events: {
        idle: (map) => {
          this.mapRef = map;
          // $log.info('Zoom:' + map.zoom)
          if (!this.isReady) {
            this.isReady = true;
            google.maps.event.trigger(map, 'resize');
            this.rectangleSelectSession.setMapInstance(map);
            // centerMap();
            // resizeService.resize();
          }
        },
        click: () => {
          if (this.rectangleSelectSession.consumeSkipNextClick()) {
            return;
          }
          this.$timeout(0).then(() => {
            this._closeAgentTooltip();
            this._hideServiceTooltip();
          })
        }
      },
      clusterOptions: {
        gridSize: this.clusterGridSizes.M,
        maxZoom: 12,
        styles: [
          {
            height: 49,
            width: 49,
            url: 'assets/images/icons/cluster/small.svg',
            textColor: '#424242',
            textSize: 14,
            fontWeight: 'bold'
          },
          {
            height: 64,
            width: 64,
            url: 'assets/images/icons/cluster/large.svg',
            textColor: '#424242',
            textSize: 14,
            fontWeight: 'bold'
          }],
        zoomOnClick: true
      },
      depotsClusterOptions: {
        gridSize: 2,
        maxZoom: 23,
        zoomOnClick: false,
        styles: this.mapsCommonService.getDepotClusterIcons()
        // zoomOnClick: false,
      },
      options: {
        styles: this.mapsCommonService.getDefaultStyle(),
        scaleControl: true,
        mapTypeControl: false
      },
      bounds: {},
      heatLayerEnabled: false,
      agentsMarkersLayerEnabled: true,
      agentTaskMarkersLayerEnabled: true,
      accountsMarkersLayerEnabled: true,
      depotsMarkersLayerEnabled: true,
      routeLayerEnabled: true,
      servicesLayerEnabled: true,
      agentsMarkersLayerCallback: (layer) => {
        this.agentsMarkersLayer = layer;

        if (this.agents?.length) {
          this._setAgents(this.agents);
        }

        // Click Listener
        this.agentsMarkersLayer.addListener("click", (event) => {
          const agent = event.feature.getProperty("ref");
          if (!this.$mdMedia('gt-md')) {
            this._openAgentTooltip(agent);
          } else {
            this.selectedAgentChanged({agent: agent});
          }
        });

        // Mouse Over Listener
        this.agentsMarkersLayer.addListener("mouseover", (event) => {
          const agent = event.feature.getProperty("ref");

          //Highlight Tasks
          this.$timeout(0).then(() => {
            this._openAgentTooltip(agent);
          });
        });

        // Mouse Out Listener
        this.agentsMarkersLayer.addListener("mouseout", (event) => {
          this.$timeout(0).then(() => {
            this._closeAgentTooltip();
          });
        });


      },
      agentTaskMarkersLayerCallback: (layer) => {
        this.agentTaskMarkersLayer = layer;
      },
      accountsMarkersLayerCallback: (layer) => {
        this.accountsMarkersLayer = layer;

        if (this.accounts?.length) {
          this._setAccounts(this.accounts);
        }

        // Mouse Over Listener
        this.accountsMarkersLayer.addListener("mouseover", (event) => {
          const account = event.feature.getProperty("ref");
          this.depotInfoWindow.isFocused = true;
          this.$timeout(this.TOOLTIP_TIMEOUT_MS).then(() => {
            if (!this.depotInfoWindow.show && this.depotInfoWindow.isFocused) {
              this.depotInfoWindow.coords = _.get(account, 'address.location');
              this.depotInfoWindow.show = true;
              this.depotInfoWindowModel = account;
            }
          });
        });

        // Mouse Out Listener
        this.accountsMarkersLayer.addListener("mouseout", (event) => {
          this.$timeout(0).then(() => {
            if (this.depotInfoWindow) {
              this.depotInfoWindow.show = false;
              this.depotInfoWindow.isFocused = false;
            }
            this.depotInfoWindowModel = undefined;
          });
        });

      },
      depotsMarkersLayerCallback: (layer) => {
        this.depotsMarkersLayer = layer;

        if (this.depots?.length) {
          this._setDepots(this.depots);
        }

        // Mouse Over Listener
        this.depotsMarkersLayer.addListener("mouseover", (event) => {
          const depot = event.feature.getProperty("ref");
          this.depotInfoWindow.isFocused = true;
          this.$timeout(this.TOOLTIP_TIMEOUT_MS).then(() => {
            if (!this.depotInfoWindow.show && this.depotInfoWindow.isFocused) {
              this.depotInfoWindow.coords = _.get(depot, 'address.location');
              this.depotInfoWindow.show = true;
              this.depotInfoWindowModel = depot;
            }
          })
        });

        // Mouse Out Listener
        this.depotsMarkersLayer.addListener("mouseout", (event) => {
          this.$timeout(0).then(() => {
            if (this.depotInfoWindow) {
              this.depotInfoWindow.show = false;
              this.depotInfoWindow.isFocused = false;
            }
            this.depotInfoWindowModel = undefined;
          });
        });

      },
      routeLayerCallback: (layer) => {
        this.routeDataLayerRef = layer;

        // Add events connection to data layer
        this.routeDataLayerRef.addListener("mouseover", (event) => {
          const taskId = event.feature.getProperty("id");
          // this.onActivityHover({id: activityId, $event: event});
        });

        if (this.route) {
          this.setRoute(this.route);
        }

      },
      servicesLayerCallback: (layer) => {
        this.servicesDataLayerRef = layer;

        // Add events connection to data layer

        this.servicesDataLayerRef.addListener("click", (event) => {

          this.$timeout(300).then(() => {
            if (this.isDoubleClick) {
              this.isDoubleClick = false;
              return;
            }

            const serviceId = event.feature.getProperty("serviceId");
            const shouldAdd = !_.includes(this.selectedServiceIds, serviceId);
            const currentSelectedIds = shouldAdd ?
              _.concat(this.selectedServiceIds, [serviceId]) :
              _.filter(this.selectedServiceIds, function (id) {
                return id !== serviceId;
              })

            this.$timeout(0).then(() => {
              this.onSelectedServicesChanged(currentSelectedIds);

              if (shouldAdd) {
                this.onAddDeliveries([serviceId]);
              }

            })

          })

        });

        this.servicesDataLayerRef.addListener("dblclick", (event) => {

          this.isDoubleClick = true;
          this._showServiceTooltip(event);

        });


        this.servicesDataLayerRef.addListener("mouseover", (event) => {
          this._showServiceTooltip(event);
        });


        this.servicesDataLayerRef.addListener("mouseout", (event) => {
          this._hideServiceTooltip();
        });

        if (this.services) {
          this.setDeliveries(this.services);
        }

      },
      heatLayerCallback: (layer) => {
        this.heatDataLayerRef = layer;
        this.heatDataLayerRef.set("radius", 30);
      },
      control: {}
    };
    this.agentInfoWindow.show = false;
    this.polygonEvents = {
      click: (polygon, eventName, model) => {
        if (this.rectangleSelectSession.isRectangleActive()) {
          return;
        }
        this.toggleServiceIds(this.getServiceIdsFromPolygon(polygon)).then((response) => {
          polygon.setOptions(
            this.getPolygonStyleBySelection(response.isSelected)
          );
          this.onSelectedServicesChanged(response.selectedIds);
        });
      },
      mouseover: (marker, event, model) => {
        if (this.rectangleSelectSession.isDrawingRectangle()) {
          return;
        }
        const map = marker.map;
        const contentString =
          '<div style="text-align: center; width: 100%">' + escapeHtml(_.get(model, 'fill.name')) + '</div>';
        this.infowindow.setPosition(this.mapsCommonService.getPolygonBounds(model.path).getCenter());
        this.infowindow.setContent(contentString);
        this.infowindow.open(map, marker);
      },
      mouseout: () => {
        this.infowindow.close();
      },
      mousedown: (polygon, eventName, model, args) => {
        this.rectangleSelectSession.handleMouseDown(_.get(args, '0'));
      },
      mousemove: (polygon, eventName, model, args) => {
        this.rectangleSelectSession.handleMouseMove(_.get(_.get(args, '0'), 'latLng'));
      },
      mouseup: () => {
        this.rectangleSelectSession.handleMouseUp();
      }
    };
    this.depotClusterEvents = {
      click: (cluster, clusterModels) => {
        const serviceIdsToToggle = _.map(clusterModels, (cluster) => {
            return cluster.serviceId
          }),
          selectedServiceIds = angular.copy(this.selectedServiceIds),
          doSelectAll = _.isUndefined(_.find(clusterModels, (clusterModel) => {
            return _.isEqual(clusterModel.selected, true)
          }));

        if (doSelectAll) {
          const serviceIdsToAdd = _.difference(serviceIdsToToggle, selectedServiceIds);
          this.selectedServiceIds = selectedServiceIds.concat(serviceIdsToAdd);
          this.onAddDeliveries(serviceIdsToAdd);

        } else {
          this.selectedServiceIds = _.filter(selectedServiceIds, (serviceId) => {
            return _.isEqual(_.indexOf(serviceIdsToToggle, serviceId), -1)
          });
        }

        this.$timeout(0).then(() => {
          this.onSelectedServicesChanged(selectedServiceIds);
        })
      },
      // clusteringend: function (clustersObject) {
      //     // clustersObject.zoomOnClick_ = clustersObject.activeMap_.zoom < 22;
      //
      //     _.forEach(clustersObject.clusters_, function (cluster) {
      //         var markers = cluster.markers_.values(),
      //             atLeastOneMarkerSelected = _.find(markers, function (marker) {
      //                 return _.isEqual(marker.models.selected, true);
      //             }),
      //             isAllSelected = _.isUndefined(_.find(markers, function (marker) {
      //                 return _.isEqual(marker.models.selected, false);
      //             }));
      //
      //         if (markers.length > 1) {
      //             if (isAllSelected) {
      //                 cluster.clusterIcon_.url_ = 'assets/images/icons/depot-selected.png';
      //                 cluster.clusterIcon_.fontWeight_ = 'bolder';
      //
      //             } else if(atLeastOneMarkerSelected) {
      //                 cluster.clusterIcon_.url_ = 'assets/images/icons/depot.png';
      //                 cluster.clusterIcon_.fontWeight_ = 'bolder';
      //                 cluster.clusterIcon_.textColor_ = 'red';
      //
      //             } else {
      //                 cluster.clusterIcon_.url_ = 'assets/images/icons/depot.png';
      //                 cluster.clusterIcon_.fontWeight_ = 'bold';
      //             }
      //         }
      //     })
      // }
    };

    this.serviceAreasService.getAll({})
      .then((serviceAreas) => {
        this.serviceAreaList = serviceAreas;
        this.setMapPolygons(serviceAreas)
      })

    this.uiGmapIsReady.promise(1).then((maps) => {
      this._whenMapReady(() => {
        this.mapInstance = this.map.control.getGMap();
        this.drawSession.setMapInstance(this.mapInstance);
        this.drawSession.enable();
        this.rectangleSelectSession.setMode('pan');
      });
    });

    this.mapFactoryService.getBrowserLocation()
      .then((res: any) => {
        this.myLocation = this.mapsCommonService.buildMyLocationMarker(res.coords);
      })
      .catch((err) => {

      })
  }

  $onDestroy() {
    this.rectangleSelectSession.destroy();
    this.drawSession.destroy();
  }

  $onChanges(changes) {
    // Selected Delivery-Ids Changed
    if (changes.selectedServiceIds && !changes.selectedServiceIds.isFirstChange()) {

      const currentSelectedServiceIds = _.get(changes.selectedServiceIds, 'currentValue', []),
        previousSelectedServiceIds = _.get(changes.selectedServiceIds, 'previousValue', []),
        idsToUnSelect = _.difference(previousSelectedServiceIds, currentSelectedServiceIds),
        idsToSelect = _.difference(currentSelectedServiceIds, previousSelectedServiceIds);

      const serviceIdsToUpdate = _.filter(_.concat(idsToUnSelect, idsToSelect), (serviceId) => {
        return !!_.includes(this.services.map(s => s.id), serviceId);
      });

      if (serviceIdsToUpdate.length) {
        this.updateFeatureStyleByServiceIds(serviceIdsToUpdate);

        if (this.isClusterEnabled) {
          this.$timeout(0).then(() => {
            this.reInitCluster();
          })
        }
      }
    }


    // Delivery Ids Changed
    if (changes.services && this.services && !changes.services.isFirstChange()) {
      if (this.servicesDataLayerRef) {
        const currentServices = _.get(changes.services, 'currentValue', []),
          previousServices = _.get(changes.services, 'previousValue', []),
          servicesToRemove = _.differenceBy(previousServices, currentServices, 'id'),
          servicesToAdd = _.differenceBy(currentServices, previousServices, 'id');

        // Remove Tasks
        if (servicesToRemove.length) {
          this.servicesDataLayerRef.forEach((feature) => {
            const serviceId = feature.getProperty('serviceId');
            if (_.includes(servicesToRemove.map((s: any) => s.id), serviceId)) {
              this.servicesDataLayerRef.remove(feature);
            }
          });
          this.services = _.filter(this.services, (s) => {
            return !_.includes(servicesToRemove.map((s: any) => s.id), s.id);
          })
        }

        // Add Tasks
        if (servicesToAdd.length) {
          this.setDeliveries(servicesToAdd);
        }

        if (this.isClusterEnabled) {
          this.$timeout(0)
            .then(() => {
              this.reInitCluster();
            })
        }

      }
    }

    // Agents Changed
    if (changes.agents && this.agents) {
      const currentAgents = changes.agents.currentValue,
        previousAgents = changes.agents.previousValue;

      if (currentAgents.length !== previousAgents.length || currentAgents.length === previousAgents.length) {

        const agentsServiceAreaIds = _.chain(currentAgents)
          .filter((agent) => {
            return _.get(agent, 'agentPreferencesReference.priorityServiceAreas')
          })
          .map((agent) => agent.agentPreferencesReference.priorityServiceAreas)
          .flatten()
          .uniq()
          .value()

        if (agentsServiceAreaIds.length) {
          this.getServiceAreas(agentsServiceAreaIds)
            .then((serviceAreas) => {
              this.serviceAreasList = _.mapKeys(serviceAreas, (area) => {
                return area.areaId;
              });
            })
        }

        if (this.agentsMarkersLayer) {

          const agentsToUpdate = currentAgents.filter(ca => {
            const prevAgentValue = previousAgents.find(pa => pa.id === ca.id);
            if (!prevAgentValue || !_.isEqual(prevAgentValue, ca)) {
              return ca;
            }
          });

          this.agentsMarkersLayer.forEach((feature) => {
            const agentRef = feature.getProperty("ref");
            const id = feature.getProperty('id');
            const agentToUpdateIndex = agentsToUpdate.findIndex(a => a.id === agentRef.id);
            const shouldRemove = !_.includes(currentAgents, id);

            if (!!shouldRemove || agentToUpdateIndex > -1) {
              this.agentsMarkersLayer.remove(feature);
            }
          });
          this._setAgents(agentsToUpdate);

        }

      }
    }

    // Depots Changed
    if (changes.depots && this.depots.length) {
      let currentValues = _.get(changes.depots, 'currentValue', []),
        previousValues = _.get(changes.depots, 'previousValue', []),
        depotsToRemove = _.differenceBy(previousValues, currentValues, 'id'),
        depotsToAdd = _.difference(currentValues, previousValues, 'id');


      // Add/Remove Depots
      if (this.depotsMarkersLayer) {
        // Remove Depots
        if (depotsToRemove.length) {
          const idsToRemove = _.map(depotsToRemove, 'id');
          this.depotsMarkersLayer.forEach((feature) => {
            const id = feature.getProperty('id');
            if (_.includes(idsToRemove, id)) {
              this.depotsMarkersLayer.remove(feature);
            }
          });
        }

        // Add Depots
        if (depotsToAdd.length) {
          this._setDepots(depotsToAdd);
        }
      }

    }

    // Accounts Changed
    if (changes.accounts && this.accounts.length) {
      let currentValues = _.get(changes.accounts, 'currentValue', []),
        previousValues = _.get(changes.accounts, 'previousValue', []),
        accountsToRemove = _.differenceBy(previousValues, currentValues, 'id'),
        accountsToAdd = _.difference(currentValues, previousValues, 'id');


      // Add/Remove Accounts
      if (this.accountsMarkersLayer) {
        // Remove Accounts
        if (accountsToRemove.length) {
          const idsToRemove = _.map(accountsToRemove, 'id');
          this.accountsMarkersLayer.forEach((feature) => {
            const id = feature.getProperty('id');
            if (_.includes(idsToRemove, id)) {
              this.accountsMarkersLayer.remove(feature);
            }
          });
        }

        // Add Accounts
        if (accountsToAdd.length) {
          this._setAccounts(accountsToAdd);
        }
      }

    }

    if (changes.route && !changes.route.isFirstChange()) {
      if (this.routeDataLayerRef) {
        this.routeDataLayerRef.forEach((feature) => {
          this.routeDataLayerRef.remove(feature);
        });
        if (this.route) {
          this.setRoute(this.route);
        }
      }
    }

    // Selected Agent Changed
    if (changes.selectedAgent && !changes.selectedAgent.isFirstChange()) {
      const currentSelectedAgent = changes.selectedAgent.currentValue,
        previousSelectedAgent = changes.selectedAgent.previousValue,
        currentSelectedAgentTaskIds = _.get(currentSelectedAgent, 'itineraryInfo.taskIdsExt', []),
        previousSelectedAgentTaskIds = _.get(previousSelectedAgent, 'itineraryInfo.taskIdsExt', []);

      this.agentTaskMarkers = [];

      if (this.selectedAgent) {
        if (
          !_.isEqual(currentSelectedAgent.id, _.get(previousSelectedAgent, 'id')) ||
          !_.isEqual(currentSelectedAgentTaskIds, previousSelectedAgentTaskIds)
        ) {
          this.filters.itinerary = true;
          this.getTasks(currentSelectedAgentTaskIds).then(
            (tasks) => {
              if (previousSelectedAgent) {
                this.removeTasksFromDataLayer([previousSelectedAgent.id]);
              }
              this.setTaskMarkers(tasks, true);
            }
          )
        }
      } else {
        this.removeTasksFromDataLayer();
      }
    }


    if (changes.selectedServiceAreaIds && !changes.selectedServiceAreaIds.isFirstChange()) {
      this.setMapPolygons(this.serviceAreaList);
    }


    // Highlighted Task Marker (with info window)
    if (changes.highlightedTaskId && !changes.highlightedTaskId.isFirstChange()) {
      const currentHighlightedTaskId = changes.highlightedTaskId.currentValue;

      const selectedAgentTaskMarker = _.find(this.agentTaskMarkers, function (agentTaskMarker) {
        return _.isEqual(agentTaskMarker.id, currentHighlightedTaskId)
      });
      this.activateInfoWindow(selectedAgentTaskMarker)
    }


    if (changes.from && !changes.from.isFirstChange() ||
      changes.to && !changes.to.isFirstChange()) {
      this.slaDates = this.filters.colorizeBy === 'SLA' ? this.getSlaDates(this.from, this.to) : undefined;
    }
  }

  // ******************************
  //        Public methods
  // ******************************

  onMapTypeChange(isSatelliteEnabled) {
    this.map.options.mapTypeId = google.maps.MapTypeId[isSatelliteEnabled ? this.mapTypeIds.satellite : this.mapTypeIds.roadmap];
    if (isSatelliteEnabled) {
      this.filters.traffic = false;
    }
  }

  onTasksColorizeChange(value) {
    this.slaDates = value === 'SLA' ? this.getSlaDates(this.from, this.to) : undefined;

    // Set feature style by its properties
    this.servicesDataLayerRef.setStyle((feature) => {
      return this.getServiceFeatureStyle(feature);
    });
  }

  centerMap() {
    if (this.servicesDataLayerRef) {
      let markers = [];
      this.servicesDataLayerRef.forEach(function (feature) {
        const address = feature.getProperty('address');
        if (!!address) {
          const fakeMarker = new google.maps.MVCObject();
          fakeMarker.set('coords', {'latitude': address.location.lat, 'longitude': address.location.lng});
          markers.push(fakeMarker);
        }
      })
      this.agentTaskMarkersLayer.forEach((feature) => {
        const address = feature.getProperty('address');

        if (address && address.location) {
          const fakeMarker = new google.maps.MVCObject();
          fakeMarker.set('coords', {'latitude': address.location.lat, 'longitude': address.location.lng});
          markers.push(fakeMarker);
        }
      })
      this.mapsCommonService.centerMapByBounds(this.map, markers);
    }
  }

  onToggleTasksFilter(isEnabled) {
    if (isEnabled) {
      this.map.heatLayerEnabled = false;
      if (this.isClusterEnabled) {
        this.onSetClusters(true);
        this.map.servicesLayerEnabled = false;
      } else {
        this.map.servicesLayerEnabled = true;
      }
    } else {
      this.map.servicesLayerEnabled = false;
      this.clearCluster();
    }
  }

  onTogglePolygonsFilter(isEnabled) {
    _.forEach(this.mapPolygons, (polygon) => {
      polygon.visible = isEnabled;
    });
  }

  onToggleHeatLayerFilter(isEnabled) {
    this.map.heatLayerEnabled = isEnabled;
    if (isEnabled) {
      this.map.servicesLayerEnabled = false;
    }
  }

  onToggleAgentsByGpsPermissionsChange() {
    if (this.agentsMarkersLayer) {
      // Set feature style by its properties
      this.agentsMarkersLayer.setStyle((feature) => {
        return this.getAgentFeatureStyle(feature);
      });
    }
  }

  onTaskMarkerClick(marker, eventName, model) {
    this.updateSelectedServiceIds([model.serviceId]);
  }

  onAgentTaskMarkerClick(marker, eventName, model) {
    this.highlightedTaskChanged({serviceId: model.serviceId, taskId: model.id});
  }

  clearDepotsActiveWindow() {
    if (this.depotActiveWindow) {
      this.depotActiveWindow.show = false;
    }
    this.windowParams = {}
  }

  clearAgentActiveWindow() {
    if (this.agentActiveWindow) {
      this.agentActiveWindow.show = false;
    }
    this.windowParams = {}
  }

  onSetClusters(isEnabled, servicesLayerEnabled?) {
    this.isClusterEnabled = isEnabled;

    if (!this.markerCluster) {
      this.markerCluster = new MarkerClusterer(this.mapRef, null, {
        gridSize: this.clusterGridSizes.M,
        maxZoom: 12,
        styles: [
          {
            height: 49,
            width: 49,
            url: 'assets/images/icons/cluster/small.svg',
            textColor: '#424242',
            textSize: 14,
            fontWeight: 'bold'
          },
          {
            height: 64,
            width: 64,
            url: 'assets/images/icons/cluster/large.svg',
            textColor: '#424242',
            textSize: 14,
            fontWeight: 'bold'
          }],
        zoomOnClick: true
      });
    }

    if (isEnabled) {
      this.reInitCluster();
    } else {
      this.clearCluster();
    }

    if (!_.isUndefined(servicesLayerEnabled)) {
      this.map.servicesLayerEnabled = servicesLayerEnabled;
    }
  }


  reInitCluster() {
    if (this.servicesDataLayerRef) {

      if (this.markerCluster) {
        this.markerCluster.clearMarkers();
      }

      this.servicesDataLayerRef.forEach((feature) => {
        const serviceId = feature.getProperty('serviceId'),
          purpose = feature.getProperty('purpose'),
          status = feature.getProperty('status'),
          taskSpec = feature.getProperty('taskSpec');

        const from = this.filters.colorizeBy === 'SLA' ? this.from : undefined;
        const to = this.filters.colorizeBy === 'SLA' ? this.to : undefined;
        const slaColorIndex = this.slaDates ? this.mapsCommonService.getTaskColorIndexByDateRange(from, to, taskSpec.notAfter) : undefined;
        const isSelected = _.includes(this.selectedServiceIds, serviceId);

        const marker = new google.maps.Marker({
          position: feature.getGeometry().get(),
          icon: this.mapsCommonService.getTaskMarkerIconNew(purpose, status, isSelected, slaColorIndex)
        });
        this.markerCluster.addMarker(marker);
      });

      this.map.servicesLayerEnabled = false;
      this.markerCluster.repaint();
    }
  }

  clearCluster() {
    if (this.markerCluster) {
      const clusterMarks = this.markerCluster.getMarkers();
      for (let i in clusterMarks) {
        clusterMarks[i].setMap(null);
      }
      this.markerCluster.clearMarkers();
    }
  }

  // ******************************
  //        Private methods
  // ******************************


  // Get //
  private getTasks(taskIds) {
    return this.taskRef.$asyncValues(taskIds);
  }

  private getTasksByServices(services) {
    const deferred = this.$q.defer();
    let tasks = [];

    _.forEach(services, (s) => {
      tasks = tasks.concat(s.taskList);
    });

    deferred.resolve(tasks);
    return deferred.promise;
  }

  private getPolygonStyleBySelection(isSelected) {
    return {
      fillOpacity: isSelected ? 0.7 : 0.4,
      strokeWeight: isSelected ? 3 : 2
    };
  }

  private getServiceIdsFromPolygon(polygon) {
    let serviceIds = [];
    this.servicesDataLayerRef.forEach((feature) => {
      const geo = feature.getGeometry().get();
      //FIXME NOT SURE ABOUT THIS AT ALL !
      if (google.maps.geometry.poly.containsLocation(geo, polygon)) {
        const serviceId = feature.getProperty('serviceId');
        serviceIds.push(serviceId)
      }
    });
    return serviceIds;
  }

  private getIdsToSelectByBounds(bounds: google.maps.LatLngBounds) {
    const serviceIds = [];
    this.servicesDataLayerRef.forEach((feature) => {
      const geo = feature.getGeometry().get();
      if (bounds.contains({lat: geo.lat(), lng: geo.lng()})) {
        const serviceId = feature.getProperty('serviceId');
        serviceIds.push(serviceId)
      }
    });
    return serviceIds;
  }

  private getIdsToSelectByShape(shape) {
    return this.getIdsToSelectByBounds(shape.getBounds());
  }

  onSelectHandTool() {
    this.drawSession.selectHandTool();
    this.rectangleSelectSession.setMode('pan');
  }

  onSelectRectangleTool() {
    this.drawSession.selectHandTool();
    this.drawSession.drawToolMode = 'rectangle';
    this.rectangleSelectSession.setMode('rectangle');
  }

  onSelectPolygonTool() {
    this.rectangleSelectSession.setMode('pan');
    this.drawSession.selectPolygonTool();
  }

  private _applyLayerClickability() {
    if (this.servicesDataLayerRef) {
      this.servicesDataLayerRef.setStyle((feature) => {
        return this.getServiceFeatureStyle(feature);
      });
    }
  }

  private getHeatLayerMarkersLocationData() {
    let markerLocations = [];

    if (this.servicesDataLayerRef) {
      this.servicesDataLayerRef.forEach((feature) => {
        const latLng = feature.getGeometry().get();
        markerLocations.push(latLng)
      })
    }
    return new google.maps.MVCArray(markerLocations);
  }

  private updateSelectedServiceIds(serviceIds) {

    const selectedServiceIds = angular.copy(this.selectedServiceIds);

    _.forEach(serviceIds, (serviceId) => {
      var selectedServiceIndex = _.indexOf(this.selectedServiceIds, serviceId),
        isServiceSelected = !_.isEqual(selectedServiceIndex, -1);

      if (isServiceSelected) {
        selectedServiceIds.splice(selectedServiceIndex, 1);
      } else {
        selectedServiceIds.push(serviceId);
        this.onAddDeliveries([serviceId]);
      }
    });
    this.onSelectedServicesChanged(selectedServiceIds);
  }

  private onSelectedServicesChanged(selectedIds: string[]) {
    const selectedServices = this.services.filter((s) => selectedIds.includes(s.id));
    this.selectedServicesChanged({selectedServices: selectedServices});
  }

  private onAddDeliveries(serviceIds: string[]) {
    const selectedServices = this.services.filter((s) => serviceIds.includes(s.id));
    this.addDeliveries({selectedServices: selectedServices})
  }

  private toggleServiceIds(idsToToggle) {
    let selectedIdsCopy = angular.copy(this.selectedServiceIds),
      unselectedMarkerIds = _.difference(idsToToggle, this.selectedServiceIds);

    if (_.isEmpty(unselectedMarkerIds)) {
      selectedIdsCopy = _.chain(selectedIdsCopy)
        .filter((serviceId) => {
          return _.indexOf(idsToToggle, serviceId) === -1
        })
        .uniq()
        .value();
    } else {
      selectedIdsCopy = selectedIdsCopy.concat(idsToToggle);
      selectedIdsCopy = _.uniq(selectedIdsCopy);
    }

    return this.$q.when({selectedIds: selectedIdsCopy, isSelected: !_.isEmpty(unselectedMarkerIds)});
  }

  private addCustomPolygon(polygon) {
    polygon.id = this.UUIDService.generate();
    this.customPolygons.push(polygon);
  }

  private selectServiceIds(idsToSelect) {
    let selectedIdsCopy = angular.copy(this.selectedServiceIds),
      unselectedMarkerIds = _.difference(idsToSelect, this.selectedServiceIds);

    if (!_.isEmpty(unselectedMarkerIds)) {
      selectedIdsCopy = selectedIdsCopy.concat(unselectedMarkerIds);
      selectedIdsCopy = _.uniq(selectedIdsCopy);
      this.onSelectedServicesChanged(selectedIdsCopy);
    }
    return this.$q.when();
  }

  private addPolygonClickEventListener(polygon) {
    google.maps.event.addListener(polygon, 'click', (event) => {
      this.togglePolygonServiceIds(polygon);
    });
  }

  private togglePolygonServiceIds(polygon) {
    this.toggleServiceIds(this.getServiceIdsFromPolygon(polygon)).then((response) => {
      polygon.setOptions(this.getPolygonStyleBySelection(response.isSelected));
      this.onSelectedServicesChanged(response.selectedIds);
    });
  }

  private activateInfoWindow(markerModel) {
    if (this.activeWindow && !_.isEqual(this.activeWindow, markerModel)) {
      this.activeWindow.show = false;
      this.activeWindow = {};
    }

    //Data passed to info-window
    if (markerModel) {
      this.windowParams = {
        taskSpec: markerModel.taskSpec,
        purposeColors: this.tasksConstants.typesToColor
      };

      markerModel.show = !markerModel.show;
      this.activeWindow = markerModel;
    }
  }

  private activateAgentInfoWindow(markerModel) {
    const serviceAreas = _.map(_.get(markerModel, 'agentPreferencesReference.priorityServiceAreas'), (areaId) => {
      return this.serviceAreasList[areaId].areaName;
    });
    const serviceAreaIds = _.get(markerModel, 'agentPreferencesReference.priorityServiceAreas');

    if (this.agentActiveWindow && !_.isEqual(this.agentActiveWindow, markerModel)) {
      this.agentActiveWindow = {};
    }
    //Data passed to info-window
    if (markerModel) {
      this.agentInfoWindowModel = {
        agentId: markerModel.id,
        agent: markerModel.user,
        agentStatus: markerModel.status,
        agentType: markerModel.agentType,
        serviceAreas: serviceAreas,
        serviceAreaIds: serviceAreaIds,
        skills: markerModel.skills,
        vehicle: markerModel.vehicle,
        lastKnownLocation: markerModel.lastKnownLocation,
        addressZoneId: _.get(markerModel.lastKnownLocation, 'zoneId'),
        configZoneId: this.splitService.getTimeZone(),
        itineraryInfo: markerModel.itineraryInfo,
        isFocused: true
      };

      this.agentActiveWindow = markerModel;
      this.agentActiveWindow.show = true;
    }
  }

  private getServiceAreas(serviceAreaIds) {
    return this.serviceAreasRef.$asyncValues(serviceAreaIds)
      .then((serviceAreas) => {
        return serviceAreas;
      })
      .catch((error) => {
        this.$log.error('Failed to get serviceAreas by branchIds,' +
          'deliveriesQueryMap@ctrl.$_getServiceAreasFromBranches', error)
      })
  }

  private _whenMapReady(callback, attempt = 0) {
    const control = this.map && this.map.control;
    if (control && _.isFunction(control.getGMap) && control.getGMap()) {
      callback();
      return;
    }
    if (attempt >= 40) {
      return;
    }
    this.$timeout(50).then(() => this._whenMapReady(callback, attempt + 1));
  }

  private setMapPolygons(serviceAreaList) {
    const selectedServiceAreas = _.filter(serviceAreaList, (area) => {
      return _.indexOf(this.selectedServiceAreaIds, area.areaId) !== -1;
    });
    this.mapPolygons = this.mapsCommonService.buildPolygons(selectedServiceAreas, this.filters.polygons);

  }

  private getSlaDates(notBefore, notAfter) {
    const from = this.moment(notBefore),
      to = this.moment(notAfter),
      diffInMs = Math.abs(this.moment(from).diff(to)),
      gap = 4,
      gapDiff = diffInMs / gap,
      dates = [];

    let value = notBefore;

    _.times(gap + 1, (i) => {
      dates.push(value);
      value += gapDiff;
    })

    // while (value < notAfter) {
    //     dates.push(value);
    //     value += gapDiff;
    // }
    return dates;
  }

  private setMarkersVisibility(markers, isVisible) {
    _.forEach(markers, (m) => {
      m.setVisible(isVisible);
    });
  }

  private setDeliveries(services) {
    this.getTasksByServices(services)
      .then((tasks) => {
        this.setServicesTasksOnLayer(tasks);
      });
  }

  private setServicesTasksOnLayer(tasks) {
    if (this.servicesDataLayerRef) {
      let geoJson = this.mapsCommonService.convertTasksToGeoJson(tasks);

      // Add routes to layer
      this.servicesDataLayerRef.addGeoJson(geoJson);

      // Set feature style by its properties
      this.servicesDataLayerRef.setStyle((feature) => {
        return this.getServiceFeatureStyle(feature);
      });

      this.heatDataLayerRef.setData(this.getHeatLayerMarkersLocationData());
    }
  }

  private setRoute(route) {
    if (this.routeDataLayerRef) {
      const geoJson = this.mapsCommonService.convertRoutedTasksToGeoJson(route.taskListExt, route);

      // Add routes to layer
      this.routeDataLayerRef.addGeoJson(geoJson);

      // Set feature style by its properties
      this.routeDataLayerRef.setStyle((feature) => {
        return this.getRouteFeatureStyle(feature);
      });
    }
  }

  private _setAgents(agents) {
    if (this.agentsMarkersLayer) {
      const geoJson = this.mapsCommonService.convertAgentsToGeoJson(agents);

      // Add routes to layer
      this.agentsMarkersLayer.addGeoJson(geoJson);

      // Set feature style by its properties
      this.agentsMarkersLayer.setStyle((feature) => {
        return this.getAgentFeatureStyle(feature);
      });
    }
  }

  private _setAccounts(agents) {
    if (this.accountsMarkersLayer) {
      const geoJson = this.mapsCommonService.convertAccountsToGeoJson(agents);

      // Add routes to layer
      this.accountsMarkersLayer.addGeoJson(geoJson);

      // Set feature style by its properties
      this.accountsMarkersLayer.setStyle((feature) => {
        return this.getAccountFeatureStyle(feature);
      });
    }
  }

  private _setDepots(depots) {
    if (this.depotsMarkersLayer) {
      const geoJson = this.mapsCommonService.convertDepotsToGeoJson(depots);

      // Add routes to layer
      this.depotsMarkersLayer.addGeoJson(geoJson);

      // Set feature style by its properties
      this.depotsMarkersLayer.setStyle((feature) => {
        return this.getDepotFeatureStyle(feature);
      });
    }
  }

  private updateFeatureStyleByServiceIds(serviceIds) {

    if (!_.get(serviceIds, 'length')) {
      return;
    }

    // Removing the services need to be changed.
    this.servicesDataLayerRef.forEach((feature) => {
      const serviceId = feature.getProperty('serviceId');
      if (_.includes(serviceIds, serviceId)) {
        this.servicesDataLayerRef.remove(feature);
      }
    });

    // Re adding the services.
    this.getTasksByServices(this.services)
      .then((tasks) => {
        this.setServicesTasksOnLayer(tasks);
      });

    if (this.doCluster) {

    }
  }

  private getServiceFeatureStyle(feature) {
    let id = feature.getProperty('id'),
      type = feature.getProperty('type'),
      agentId = feature.getProperty('agentId'),
      serviceId = feature.getProperty('serviceId'),
      purpose = feature.getProperty('purpose'),
      status = feature.getProperty('status'),
      place = feature.getProperty('place'),
      taskSpec = feature.getProperty('taskSpec'),
      address = feature.getProperty('address');

    const from = this.filters.colorizeBy === 'SLA' ? this.from : undefined;
    const to = this.filters.colorizeBy === 'SLA' ? this.to : undefined;
    const slaColorIndex = (this.filters.colorizeBy === 'SLA' && this.slaDates) ? this.mapsCommonService.getTaskColorIndexByDateRange(from, to, taskSpec.notAfter) : undefined;
    const timeWindowColorIndex = this.filters.colorizeBy === 'TIME-WINDOW' ? this.mapsCommonService.getTaskColorIndexByTimeWindow(taskSpec.notBefore) : undefined;
    const isSelected = _.includes(this.selectedServiceIds, serviceId);

    return {
      // visible: _.includes(ctrl.hiddenRouteIds, routeId) ? false : ctrl.filters.routes,
      visible: true,
      // fillColor: color,
      icon: this.mapsCommonService.getTaskMarkerIconNew(purpose, status, isSelected, slaColorIndex, timeWindowColorIndex),
      clickable: !this.rectangleSelectSession?.isRectangleActive()
    }
  }

  private getAgentFeatureStyle(feature) {
    const agent = feature.getProperty('ref');
    return {
      visible: !this.filters.showAgentsWithoutGpsPermissions ?
        (this.map.agentsMarkersLayerEnabled && this.agentsService.doesAgentHasGpsPermissions(agent)) :
        this.map.agentsMarkersLayerEnabled,
      icon: this.mapsCommonService.getAgentIcon(agent)
    };
  }

  private getAccountFeatureStyle(feature) {
    return {
      visible: true,
      icon: this.mapsCommonService.getAccountIcon()
    };
  }

  private getDepotFeatureStyle(feature) {
    const displayColor = feature.getProperty('displayColor');
    return {
      visible: true,
      icon: this.mapsCommonService.buildDepotTaskIcon(feature, displayColor)
    };
  }

  private getRouteFeatureStyle(feature) {
    let featureType = feature.getProperty('type'),
      routeId = feature.getProperty('routeId'),
      color = feature.getProperty('color'),
      indexInRoute = feature.getProperty('indexInRoute'),
      isPolyline = _.isEqual(featureType, 'POLYLINE'),
      isTask = _.isEqual(featureType, 'Stopover') || _.isEqual(featureType, 'Internal'),
      isGroup = _.isEqual(featureType, 'BundledStopover'),
      isSelected = false;

    let style = {
      // visible: _.includes(ctrl.hiddenRouteIds, routeId) ? false : ctrl.filters.routes,
      visible: true,
      fillColor: color
    }

    if (isPolyline) {
      _.set(style, 'strokeColor', color);
      _.set(style, 'strokeWeight', 2);
      _.set(style, 'icons', [{
        icon: {
          path: google.maps.SymbolPath.FORWARD_OPEN_ARROW
        },
        stroke: {
          color: color || '#000000',
          weight: 1.5,
          opacity: 1
        },
        offset: '50px',
        repeat: '150px'
      }])
    } else {
      _.set(style, 'icon', (isTask || isGroup) ?
        this.mapsCommonService.buildRoutedTaskIcon(isSelected, false, color, isGroup, indexInRoute) :
        this.mapsCommonService.buildStartEndPointIcon(indexInRoute === 0))
    }

    return style;
  }

  private setTaskMarkers(tasks, doCenterMap) {
    if (this.agentTaskMarkersLayer) {
      const geoJson = this.mapsCommonService.convertItineraryTasksToGeoJson(tasks, _.get(this, 'selectedAgent.id'), true);

      // Add routes to layer
      this.agentTaskMarkersLayer.addGeoJson(geoJson);

      // Set feature style by its properties
      this.agentTaskMarkersLayer.setStyle((feature) => {
        return this.mapsCommonService.getTaskFeatureStyle(feature);
      });

      if (doCenterMap) {
        this.centerMap();
      }
    }
  }

  private removeTasksFromDataLayer(removeByAgentIds?) {
    if (this.agentTaskMarkersLayer) {
      this.agentTaskMarkersLayer.forEach((feature) => {
        if (_.get(removeByAgentIds, 'length')) {
          const featureAgentId = feature.getProperty('agentId');
          if (_.includes(removeByAgentIds, featureAgentId)) {
            this.agentTaskMarkersLayer.remove(feature);
          }
        } else {
          this.agentTaskMarkersLayer.remove(feature);
        }
      });
    }
  }

  private _openAgentTooltip(agent) {
    this.agentInfoWindow.isFocused = true;
    this.$timeout(this.TOOLTIP_TIMEOUT_MS).then(() => {
      if (this.agentInfoWindow.isFocused && !this.agentInfoWindow.show) {
        this.agentInfoWindow.coords = _.get(agent, 'lastKnownLocation.coordinates');
        this.activateAgentInfoWindow(agent);
        this.agentInfoWindow.show = true;
      }
    })
  }

  private _closeAgentTooltip() {
    this.agentInfoWindowModel = undefined;
    if (this.agentInfoWindow) {
      this.agentInfoWindow.show = false;
      this.agentInfoWindow.isFocused = false;
    }

    this.clearAgentActiveWindow();
  }

  private _showServiceTooltip(event) {
    this._hideServiceTooltip();
    this.hoveringTaskId = event.feature ? event.feature.getProperty("id") : undefined;

    this.$timeout(this.TOOLTIP_TIMEOUT_MS).then(() => {
      const taskId = event.feature.getProperty("id");
      if (this.hoveringTaskId === taskId && !this.taskInfoWindow.show) {
        const serviceId = event.feature.getProperty("serviceId");
        const serviceRef = _.find(this.services, (s) => {
          return s.id === serviceId;
        });
        const task = serviceRef ? _.find(serviceRef.taskList, (t) => {
          return t.id === taskId;
        }) : undefined;

        const taskModel = angular.copy(task);

        const geo = event.feature.getGeometry().get();
        this.taskInfoWindow.coords = {
          lat: geo.lat(),
          latitude: geo.lat(),
          lng: geo.lng(),
          longitude: geo.lng()
        };
        this.taskInfoWindow.show = true;
        if (taskModel) {
          serviceRef.proNumber
          _.set(taskModel, 'proNumber', _.get(serviceRef, 'proNumber'));
          _.set(taskModel, 'requiredSkills', _.get(serviceRef, 'requiredSkills', []));
          _.set(taskModel, 'tagNames', _.get(serviceRef, 'tagNames', []));
          _.set(taskModel, 'pricePlanName', _.get(serviceRef, 'pricePlanName'));
          // _.set(taskModel, 'volume', $filter('packageVolume')(_.get(serviceRef, 'packageList')));
          _.set(taskModel, 'configZoneId', this.splitService.getTimeZone());
          _.set(taskModel, 'packageList', _.get(serviceRef, 'packageList'));
          _.set(taskModel, 'cancellationReason', _.get(serviceRef, 'cancellationReason.reason'));
        }
        this.taskInfoWindowModel = taskModel;
      }
    });
  }

  private _hideServiceTooltip() {
    this.hoveringTaskId = undefined;
    this.taskInfoWindowModel = undefined;
    this.$timeout(0).then(() => {
      if (this.taskInfoWindow) {
        this.taskInfoWindow.show = false;
        // ctrl.taskInfoWindow.isFocused = false;
      }
    });
  }

}

angular
  .module('bringoz.admin.map')
  .component('servicesMap', {
    bindings: {
      from: '<',
      to: '<',
      services: '<',
      agents: '<',
      depots: '<?',
      accounts: '<?',
      route: '<?',
      selectedAgent: '<',
      selectedServiceIds: '<',
      selectedServiceAreaIds: '<',
      highlightedTaskId: '<',
      addDeliveries: '&',
      highlightedTaskChanged: '&',
      selectedServicesChanged: '&',
      selectedAgentChanged: '&'
    },
    template: require('./services-map.html').default,
    controller: ServicesMapComponent
  });
